import { useEffect } from "react";
import { Input, Form } from "antd";
import { getLangList } from '@/lib/i18n';
import { modalFromLayout } from "@/lib/antdElementFunction";
import { SubjectType } from './types';

interface Props {
  form: any;
  info: SubjectType;
  handleType: string;
}

function ModalSubject(props: Props) {
  const { form, info, handleType } = props;
  const subjectT: any = getLangList("subject");

  useEffect(() => {
    const { enName, cnName, description } = info ?? {};

    handleType === 'update' && form.setFieldsValue({ enName, cnName, description });
  }, [form, info, handleType]);

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
      initialValues={{
        enName: '',
        cnName: '',
        description: '',
      }}
    >
      <Form.Item
        label={subjectT.EN_NAME}
        name="enName"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
  
      <Form.Item
        label={subjectT.CN_NAME}
        name="cnName"
      >
        <Input />
      </Form.Item>
  
      <Form.Item
        label={subjectT.SUBJECT_DESCRIPTION}
        name="description"
      >
        <Input.TextArea  />
      </Form.Item>
    </Form >
  );
}

export default ModalSubject;